const bravoSuite = {
  isMostPopular: true,
  isShowContactUs: false,
  logo: '/svg/logos/logo-suite.svg',
  title: 'bravoSUITE',
  price: '3',
  unit: 'EMPLOYEES / MONTH',
  pricingPlanItem: [
    'Full access to all platforms: bravoGROWTH, bravoTALENT and bravoSURVEYS',
    "Unlimited profiling with bravoGROWTH's personality reflection tool inspired by RIASEC and MBTI methodologies",
    "Unlimited access to bravoTALENT's candidate pool and profile database",
    "Unlimited job posting to bravoTALENT's job board",
    "1 free job posting monthly to bravoTALENT's external job boards",
    'Coaching on bravoGROWTH profile test results',
    'Full customer support',
    'Unlimited surveys with bravoSURVEYS'
  ]
};

const bravoSurveys = {
  isMostPopular: false,
  isShowContactUs: true,
  logo: '/svg/logos/logo-surveys.svg',
  title: 'bravoSurveys',
  price: '1',
  unit: 'EMPLOYEES / MONTH',
  pricingPlanItem: [
    'Beautiful customized designs',
    'Insightful data reports in minutes',
    'Unlimited surveys',
    'Unlimited questions',
    'Unlimited responses ',
    'Full customers support'
  ]
};

const bravoTalents = {
  isMostPopular: false,
  isShowContactUs: false,
  logo: '/svg/logos/logo-talent.svg',
  title: 'bravoTalent',
  price: '1',
  unit: 'JOB POSTS / MONTH',
  pricingPlanItem: [
    "Unlimited access to bravoTALENT's candidate pool",
    'Complete insight into candidate profiles that have applied for your job opening',
    'bravoTALENT matches your job positioning with candidates automatically from our candidate pool',
    'Reduce hiring time and save costs with bravoTALENT all-in-one recruitment platform'
  ]
};

const bravoGrowth = {
  isMostPopular: false,
  isShowContactUs: false,
  logo: '/svg/logos/logo-growth.svg',
  title: 'bravoGrowth',
  price: '2',
  unit: 'EMPLOYEES / MONTH',
  pricingPlanItem: [
    'Candidate profiling with our personal reflection tools inspired by RIASEC and MBTI methodologies',
    'Team-map to form and manage teams based on profiles',
    'Performance overview and career path guidance',
    'CV builder',
    'Coaching on profile test results',
    'Full customer support'
  ]
};

const bravoInsights = {
  isMostPopular: false,
  isShowContactUs: false,
  logo: '/svg/logos/logo-insights.svg',
  title: 'bravoInsights',
  price: '2',
  unit: 'EMPLOYEES / MONTH',
  pricingPlanItem: [
    'Use bravoINSIGHTS to dive into valuable data generated from bravoGROWTH, bravoTALENT, and bravoSURVEYS',
    'Create beautiful dashboards and reports based on the collected data',
    'Export insightful data reports for management to drive growth'
  ]
};

export const pricingItemList = [
  bravoSuite,
  bravoGrowth,
  bravoTalents,
  bravoSurveys,
  bravoInsights
];
